<template>
    <modal :show.sync="show" :on-close="onClose">
        <div class="column content-box">
            <woot-modal-header
            :header-title="$t('ORDER.DETAILS.REFUND_MODAL.TITLE')"
        />
        </div>
        <section class="modal_body">
            <!-- selst down  -->
            <!-- <MultiselectDropdown
            :label="$t('ORDER.DETAILS.REFUND_MODAL.REFUND_METHOD.LABEL')"
            :error="$v.refund_id.$error ? $t('ORDER.DETAILS.REFUND_MODAL.REFUND_METHOD.ERROR') : ''"
            >
            <multiselect
                class="column small-12"
                v-model="refund_id"
                :options="refundPaymentsBanks.payments"
                track-by="uuid"
                label="uuid"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="true"
                :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.REFUND_METHOD.PLACEHOLDER')"
                selected-label
                :select-label="''"
                :deselect-label="''"
            />
            </MultiselectDropdown> -->

            <div v-if="refundPaymentsBanks.payments.length" class="item">
                <label>{{$t('ORDER.DETAILS.REFUND_MODAL.REFUND_METHOD.LABEL')}}</label>
                <div class="full_width">
                    <multiselect
                        class="column small-12"
                        v-model="refund_id"
                        :options="refundPaymentsBanks.payments"
                        track-by="uuid"
                        label="uuid"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.REFUND_METHOD.PLACEHOLDER')"
                        selected-label
                        :select-label="''"
                        :deselect-label="''"
                    />
                    <label v-if="$v.refund_id.$error" class="error">
                        <span class="message text_12 font_500">{{$t('ORDER.DETAILS.REFUND_MODAL.REFUND_METHOD.ERROR')}}</span>
                    </label>
                </div>
            </div>


            <div class="item">
                <label>{{$t('ORDER.DETAILS.REFUND_MODAL.ORDER_AMOUNT.LABEL')}}</label>
                <p class="text_right">{{order.grand_total}} {{order.currency}}</p>
            </div>
            <div class="item">
                <label><span>{{$t('ORDER.DETAILS.REFUND_MODAL.PAID_AMOUNT.LABEL')}}</span></label>
                <p class="text_right">{{order.paid_total}} {{order.currency}}</p>
            </div>
            <div class="item refund_field">
                <label>{{$t('ORDER.DETAILS.REFUND_MODAL.REFUND_AMOUNT.LABEL')}}</label>
                <div>
                    <input
                    v-model="refund_amount"
                    type="text"
                    class="text_right full_width"
                    :placeholder="'Refund amount eg. 10.50'"
                    :class="{ error: $v.refund_amount.$error }"
                     @input="onRefundInput"
                    />
                    <p  class="error_msg">{{$v.refund_amount.$error ? 'Only positive amount is required':""}}</p>
                </div>
            </div>


            <div v-if="isFpxBank">
                <div class="item">
                    <label>{{$t('ORDER.DETAILS.REFUND_MODAL.FPX_BANK.LABEL')}}</label>
                    <div class="full_width">
                        <multiselect
                            class="column small-12"
                            v-model="fpx_bank"
                            :options="refundPaymentsBanks.bank_list"
                            track-by="bank_code"
                            label="bank_name"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.FPX_BANK.PLACEHOLDER')"
                            selected-label
                            :select-label="''"
                            :deselect-label="''"
                        />
                        <label v-if="$v.fpx_bank.$error" class="error">
                            <span class="message text_12 font_500">{{$t('ORDER.DETAILS.REFUND_MODAL.FPX_BANK.ERROR')}}</span>
                        </label>
                    </div>
                </div>
                <!-- <MultiselectDropdown
                :label="$t('ORDER.DETAILS.REFUND_MODAL.FPX_BANK.LABEL')"
                :error="$v.fpx_bank.$error ? $t('ORDER.DETAILS.REFUND_MODAL.FPX_BANK.ERROR') : ''"
                >
                <multiselect
                    class="column small-12"
                    v-model="fpx_bank"
                    :options="refundPaymentsBanks.bank_list"
                    track-by="bank_code"
                    label="bank_name"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.FPX_BANK.PLACEHOLDER')"
                    selected-label
                    :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
                    :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
                />
                </MultiselectDropdown> -->
                <div class="item refund_field">
                    <label>{{$t('ORDER.DETAILS.REFUND_MODAL.FPX_NAME.LABEL')}}</label>
                    <div>
                        <input
                        v-model="fpx_name"
                        type="text"
                        class="full_width"
                        :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.FPX_NAME.PLACEHOLDER')"
                        :class="{ error: $v.fpx_name.$error }"
                        @blur="$v.fpx_name.$touch"
                        />
                        <p v-if="$v.fpx_name.$error" class="error_msg">{{ $t('ORDER.DETAILS.REFUND_MODAL.FPX_NAME.ERROR')}}</p>
                    </div>
                </div>

                <!-- <InputField
                    v-model="fpx_name"
                    :label="$t('ORDER.DETAILS.REFUND_MODAL.FPX_NAME.LABEL')"
                    :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.FPX_NAME.PLACEHOLDER')"
                    :error="$v.fpx_name.$error ? $t('ORDER.DETAILS.REFUND_MODAL.FPX_NAME.ERROR') : ''"
                    @blur="$v.fpx_name.$touch"
                /> -->

                <div class="item refund_field">
                    <label>{{$t('ORDER.DETAILS.REFUND_MODAL.FPX_ACCOUNT.LABEL')}}</label>
                    <div>
                        <input
                        v-model="fpx_account"
                        type="text"
                        class="full_width"
                        :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.FPX_ACCOUNT.PLACEHOLDER')"
                        :class="{ error: $v.fpx_account.$error }"
                        @blur="$v.fpx_account.$touch"
                        />
                        <p v-if="$v.fpx_account.$error" class="error_msg">{{ $t('ORDER.DETAILS.REFUND_MODAL.FPX_ACCOUNT.ERROR')}}</p>
                    </div>
                </div>

                <!-- <InputField
                    v-model="fpx_account"
                    :label="$t('ORDER.DETAILS.REFUND_MODAL.FPX_ACCOUNT.LABEL')"
                    :placeholder="$t('ORDER.DETAILS.REFUND_MODAL.FPX_ACCOUNT.PLACEHOLDER')"
                    :error="$v.fpx_account.$error ? $t('ORDER.DETAILS.REFUND_MODAL.FPX_ACCOUNT.ERROR') : ''"
                    @blur="$v.fpx_account.$touch"
                /> -->

            </div>

            <div class="modal-footer">
                <div class="medium-12 columns">
                    <woot-submit-button
                    button-text="Confirm"
                    :loading="isRefunding"
                    :disabled="isRefunding"
                    @click="onRefundAmount"
                    />
                    <button class="button clear" @click.prevent="onClose">
                    {{ $t('TEMPLATE_MSG.ADD.CANCEL_BUTTON_TEXT') }}
                    </button>
                </div>
            </div>
        </section>
    </modal>
</template>

<script>
import WootSubmitButton from '../../../../components/buttons/FormSubmitButton.vue';
import Modal from '../../../../components/Modal.vue';
import alertMixin from 'shared/mixins/alertMixin';
import OrderAPI from "../../../../api/orders";
import { required, minLength, numeric , minValue,requiredIf } from 'vuelidate/lib/validators';
// import MultiselectDropdown from "components/ui/inputs/MultiselectDropdown.vue";
// import InputField from 'components/ui/inputs/InputField.vue';

export default {
    components: {
        WootSubmitButton,
        Modal,
        // MultiselectDropdown,
        // InputField,
    },
    mixins: [alertMixin],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        onSuccess: {
            type: Function,
            default: () => {},
        },
        order: {
            type: Object,
            default: () => {},
        },
        refundPaymentsBanks: {
            type: Object,
            default: () => {},
        },
    },
    data(){
        return{
            isRefunding: false,
            refund_amount: this.order?.refund_amount || 0,

            refund_id: null,
            fpx_name: "",
            fpx_bank: null,  // bank dropdown
            fpx_account: ""
        }
    },
    computed:{
        isFpxBank(){
            return this.refund_id?.payment_method === 'fpx';
        },
    },
    watch:{
        order:{
            handler(newValue, oldValue){
                // set initial refund amount
                this.refund_amount = newValue?.refund_amount || 0;
            },
            immediate: true,
        },
    },
    validations: {
        refund_amount:{
            required: true,
            float(value) {
                return /^(\d+(\.\d+)?|\.\d+)$/.test(value);
            }
        },
        refund_id:{
            required(value) {
                return !!value;
            },
            hasList(value) {
                return this.refundPaymentsBanks?.payments?.length > 0;
            }
        },
       fpx_name: {
            required: requiredIf(function () {
                return this.isFpxBank;
            })
        },
        fpx_bank: {
            required: requiredIf(function () {
                return this.isFpxBank;
            }),
            hasBankCode(value) {
                if (!this.isFpxBank) return true; // skip check if not FPX
                return !!value;
            }
        },
        fpx_account: {
            required: requiredIf(function () {
                return this.isFpxBank;
            })
        },
    },
    methods:{
        async onRefundAmount(){
            // this.$v.$touch();
            // if (this.$v.$invalid) {
            //     console.log(this.$v);
            //     return;
            // }
            this.$v.refund_amount.$touch();
            if (this.refundPaymentsBanks?.payments?.length) this.$v.refund_id.$touch();
            if (this.isFpxBank) {
                this.$v.fpx_bank.$touch();
                this.$v.fpx_name.$touch();
                this.$v.fpx_account.$touch();
            }
            if (
                this.$v.refund_amount.$error ||
                (this.refundPaymentsBanks?.payments?.length && this.$v.refund_id.$error) ||
                (this.isFpxBank && (this.$v.fpx_bank.$error || this.$v.fpx_name.$error || this.$v.fpx_account.$error))
            ) {
                console.log(this.$v);
                return;
            }


            try {
                this.isRefunding = true;
                const payload =  {
                    amount: this.refund_amount,
                    refund_id: this.refund_id?.uuid,
                    fpx_name: this.fpx_name,
                    fpx_bank: this.fpx_bank?.bank_code,
                    fpx_account: this.fpx_account,
                }
                const result = await OrderAPI.refundAmount(this.order.id,payload)
                // dispatch get again
                this.showAlert('Refund successful');
                this.onSuccess();
                this.onClose();
            } catch (error) {
                console.log(error.response,error.message);
                this.showAlert(error.response?.data?.error||'Failed to refund amount');
            }finally{
                this.isRefunding = false;
            }
        },
        onRefundInput(e){
            let value = event.target.value;
            value = value.replace(/[^0-9.]/g, '');
            console.log({value});
            const decimalIndex = value.indexOf('.');
            if (decimalIndex !== -1) {
                value = value.slice(0, decimalIndex + 1) + value.slice(decimalIndex + 1).replace(/\./g, ''); // Only allow one decimal point
            }
            this.refund_amount = value;
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables';
@import '~dashboard/assets/scss/mixins';
@import '~dashboard/assets/scss/woot';

.modal_body{
    min-height: 300px;
    padding: 3.2rem 3.2rem;
}

.item{
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 16px;
    @include breakpoint(medium up) {
        grid-template-columns: 140px 1fr;
    }
}
.refund_field{
    display: grid;
    grid-template-columns: 1fr;
    @include breakpoint(medium up) {
        grid-template-columns: 140px 1fr;
    }
    label{
        min-width: 140px;
    }
    input{
        margin-bottom: 5px;
    }
}
.text_right{
    text-align: right;
}
.full_width{
    width: 100%;
}

.error_msg{
    // position: absolute;
    color: var(--r-400);
}

</style>

